import { api } from '@api'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Album {
  id: string
  title: string
  description: string | null
  createdByAccountId: string
  createdAt: string
  updatedAt: string
}

const fetchAlbums = async (
  params?: FetchParams,
): Promise<PaginatedResponse<Album>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }

  const url = `/albums${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Album>>(url)
  return data
}

export const usePaginateAlbums = () => {
  return usePaginate<Album>('albums', fetchAlbums)
}
